import styled from '@emotion/styled';
import React, { useState } from 'react';
import { useTranslation } from '../../../features/shared/i18n/translate/useTranslation';
import { getResponsiveImageUrl } from '../../../features/shared/image/getResponsiveImageUrl';
import { Color } from '../../../features/shared/styles/Color';
import ImageDialog from './ImageDialog';

interface IImageCardProps {
	imageSrc: string;
	alt?: string;
	className?: string;
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function ImageCard({
	imageSrc,
	alt,
	className,
	...rest
}: IImageCardProps) {
	const [isDialogOpen, setDialogOpen] = useState(false);
	const { t } = useTranslation();
	return (
		<>
			{isDialogOpen && (
				<ImageDialog
					setDialogOpen={setDialogOpen}
					imageSrc={imageSrc}
					alt={alt}
				/>
			)}
			<InvisibleButton
				aria-label={t('open_image_dialog', { imageAlt: alt })}
				onClick={() => setDialogOpen(true)}
			>
				<StyledPicture className={className} {...rest}>
					<img src={getImageCardSource(imageSrc)} alt={alt} />
				</StyledPicture>
			</InvisibleButton>
		</>
	);
}

function getImageCardSource(imageSrc: string) {
	return getResponsiveImageUrl(imageSrc, {
		fit: 'thumb',
		w: 492,
		h: 276,
	});
}

const InvisibleButton = styled.button`
	background: none;
	border: none;
	padding: 0;
	cursor: pointer;
	border-radius: 12px;
	&:focus-visible {
		outline: 2px solid black;
	}
`;

const StyledPicture = styled.picture`
	overflow: hidden;
	border-radius: 12px;
	background-color: ${Color.Neutral90};
	padding: 0;
	margin: 0;
	width: 100%;
	height: 100%;
	display: inline-block;
	aspect-ratio: 16 / 9;

	img {
		object-fit: cover;
		width: 100%;
		height: 100%;
		padding: 0;
		margin: 0;

		pointer-events: none;
		-webkit-user-drag: none;
	}
`;
